export function getDomainName() {
  try {
    const hostname = window.location.hostname; // Get the hostname (e.g., 'decathlon.store.afras.in')
    if (!hostname) throw new Error("Hostname is empty or undefined.");
    return hostname.split(".")[0]; // Extract the first part of the domain (e.g., 'decathlon')
  } catch (error) {
    console.error("Error extracting domain name:", error.message);
    return null; // Return null or a default value if an error occurs
  }
}

export const getServiceURL = () => {
  let SERVICE_URL = "http://localhost:3010/v1";

  let IS_LOCALHOST = window.location.hostname.includes("localhost");

  if (!IS_LOCALHOST) {
    SERVICE_URL = process.env.REACT_APP_SERVICE_API;
  }
  return SERVICE_URL;
};

export function getStoreInfo() {
  const storeInfo = localStorage.getItem("storeInfo");

  return storeInfo === "superAdmin" ? "superAdmin" : JSON.parse(storeInfo);
}

export const getWebSocketURL = () => {
  const serviceUrl = getServiceURL();
  try {
    const parsed = new URL(serviceUrl);
    const protocol = parsed.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${parsed.host}`;
  } catch (e) {
    const isHttps =
      typeof window !== "undefined" && window.location.protocol === "https:";
    const host =
      typeof window !== "undefined"
        ? window.location.hostname
        : "localhost";
    return `${isHttps ? "wss:" : "ws:"}//${host}:3010`;
  }
};

